import React from 'react';

function Footer() {
    return (
        <>
          <footer className="py-3" style={{ backgroundColor: '#333', color: '#fff' }}>
                <div className="container">
                    <div className="row">
                        {/* Logos à gauche */}
                        <div className="col-md-6 d-flex justify-content-start">
                            <ul className="nav">
                                <li className="nav-item">
                                    <img src="../../assets/images/bg/05.png" alt="Logo 1" style={{ width: '250px', marginRight: '10px' }} />
                                </li>
                               
                            </ul>
                        </div>

                        {/* Logos à droite */}
                        <div className="col-md-6 d-flex justify-content-end align-items-center">
                            <ul className="nav">
                                
                                <li className="nav-item">
                                    <img src="../../assets/images/bg/06.png" alt="Logo 2" style={{ width: '350px', marginRight: '10px' }} />
                                </li>
                            </ul>
                    
                        </div>
                    </div>
                </div>
            </footer>
        </> 
    );
}

export default Footer;
